export default __webpack_public_path__ + "static/Major-Expenses-Remote-Workers-Work-Space-46b81081e597e63f50246c7516a11986.jpg";